<template>
  <div>
    <Select v-model="selected"
            :placeholder="placeholder"
            :remote-method="findUser"
            :loading="loading"
            :disabled="disabled"
            @on-change="handleValueChanged"
            remote
            filterable
            clearable
            transfer>
      <Option v-for="(opt, ind) in results" :key="ind" :value="opt.id" :label="opt.name + (opt.email ? ' (' + opt.email + ')' : '')">
      </Option>
    </Select>
  </div>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'UserSelect',
  props: {
    placeholder: {
      type: String,
      default: 'Find user'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      results: [],
      loading: false,
      selected: this.$attrs.value
    }
  },
  methods: {
    eloquentsearch,
    findUser (query) {
      if (query !== '') {
        this.loading = true
        this.eloquentsearch('user', query)
          .then(resp => {
            this.results = resp.data.data
          }).finally(() => {
            this.loading = false
          })
      }
    },
    handleValueChanged (value) {
      const userInfo = _.find(this.results, { id: value })
      this.$emit('input', value)
      this.$emit('on-selected', userInfo)
    }
  },
  watch: {
    '$attrs.value' () {
      this.selected = this.$attrs.value
    }
  }
}
</script>
